import {Component, OnInit, ViewChild} from '@angular/core';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {EnumTranslateService} from '../../../services/enumTranslate-service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {ExtractionSchedulingModalComponent} from './extraction-scheduling-modal/extraction-scheduling-modal.component';
import {ExtractionService} from '../../../services/configuration/extraction.service';

@Component({
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.css']
})
export class SchedulingComponent implements OnInit {

  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  dataExtractionSchedulingList: any[];
  pleaseWait = false;
  errorMessage = '';
  successMessage = '';
  destComponent: any = ExtractionSchedulingModalComponent;

  constructor(private extractionService: ExtractionService, private modalService: GenericModalService) { }

  ngOnInit() {
    this.loadSchedulings();
  }

  loadSchedulings() {
    this.errorMessage = '';
    this.extractionService.getAllDataExtractionScheduling().subscribe(res => {
      this.dataExtractionSchedulingList = res;
      // incluir os campos tratados aqui para facilitar na ordenação...
      this.dataExtractionSchedulingList.forEach(definition => {
        definition.name = definition.dataExtractionDefinition.name;

        // quando retorna do oracle, o campo description está retornando null.
        // Portanto, preciso realizar o tratamento aqui para evitar erro na renderização da tela
        definition.description = definition.dataExtractionDefinition.description == null ? '' : definition.dataExtractionDefinition.description;

        definition.descriptionType = this.getDataExtractionDescription(definition.dataExtractionDefinition.type);
        definition.descriptionIntervalType = this.getDataExtractionIntervalDescription(definition.dataExtractionDefinition.intervalType);
        definition.enabledDescription = definition.schedulingInfo.enabled ? 'Ativo' : 'Inativo';
      });
    }, error1 => {
      this.errorMessage = error1;
      setTimeout(() => { this.errorMessage =  ''; }, 5000);
    });
  }

  getDataExtractionDescription(type) {
    return EnumTranslateService.getEnumDataExtractionType(type);
  }

  getDataExtractionIntervalDescription(type) {
    return EnumTranslateService.getEnumDataExtractionIntervalType(type);
  }

  onDeleteSchedule(definition) {
    this.successMessage = '';
    this.errorMessage = '';

    definition = ExtractionService.fixDefinitionForSerialization(definition);

    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão',
      `Confirma a exclusão de <b>${definition.dataExtractionDefinition.name}</b>?`);

    alert.then((result) => {
      if (result.value){
        this.extractionService.deleteSchedulingWithDataExtractionDef(definition).subscribe(res => {
          this.successMessage = `${definition.dataExtractionDefinition.name} excluído com sucesso`;

          setTimeout(() => {
            this.successMessage = '';
            this.loadSchedulings();
          }, 2000);
        }, error1 => {
          this.errorMessage = error1;
        });
      }
    });
  }

  onEditSchedule(schedule) {
    const result$ = this.modalService.showObjModal(this.destComponent, 'Configurar tipo de extração e agendamento', schedule);
    result$.asObservable()
      .subscribe(
        itemHasBeenSaved => {
          if (itemHasBeenSaved) { this.ngOnInit(); }
        });
  }

  onAddNew() {
    const newSchedule = {};
    const result$ = this.modalService.showObjModal(this.destComponent, 'Configurar tipo de extração e agendamento', newSchedule);
    result$.asObservable()
      .subscribe(
        itemHasBeenSaved => {
          if (itemHasBeenSaved) { this.ngOnInit(); }
        });
  }
}
